import React from "react"
import PropTypes from "prop-types"
import { compose } from "redux"
import { connect } from "react-redux"
import "./index.less"
import { Switch, Spin, Table, Popover, Button } from "antd"
import { createStructuredSelector } from "reselect"
import { getSynchronizationsWatcher } from "./actions"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import Loader from "components/Loader"
import saga from "./saga"
import reducer from "./reducer"
import { QuestionCircleFilled } from "@ant-design/icons"
import { makeSelectIsLoadingSynchronizations, makeSelectSynchronizations } from "./selectors"
import { map } from "lodash"
import { Link } from "react-router-dom"

export class Synchronization extends React.Component {
  componentDidMount() {
    this.props.getSynchronizations()
  }

  tableColumns() {
    const columns = [
      {
        title: 'Fecha',
        dataIndex: 'date',
        key: 'date',
      },
      {
        title: 'Hora',
        dataIndex: 'hour',
        key: 'hour',
      },
      {
        title: 'Estado',
        dataIndex: 'status',
        key: 'status',
      },
      {
        title: 'Colaboradores actualizados',
        dataIndex: 'count_update',
        key: 'count_update',
      },
      {
        title: 'Colaboradores nuevos',
        dataIndex: 'count_insert',
        key: 'count_insert',
      },
      {
        title: 'Colaboradores eliminados',
        dataIndex: 'count_delete',
        key: 'count_delete',
      },
      {
        title: 'Error',
        dataIndex: 'error',
        key: 'error',
      },
    ];
    return columns
  }

  showErrorLabel(type, id_synchronization){
    if([1, 2].includes(parseInt(type))) {
      return (
        <span>Error técnico 
          <Popover content={`Contacta con el servicio de soporte.`}  placement="top" >
            <QuestionCircleFilled
              style={{
                color: "#A7A3A3",
                marginLeft: "8px",
                verticalAlign: "middle",
              }}
            />
          </Popover>
        </span>
      )
    }
    if([3].includes(parseInt(type))) {
      return <Link to={`/synchronization-errors/${id_synchronization}`}>Ver errores</Link>
    }
    return <>-</>
  }
  render() {
    return (
      <div className="container-synchronization">
        <div className="container-synchronization-description">
          Visualiza el historial y estado de las sincronizaciones con Visma People. Estas se realizan a las <b>6 a.m. y 6 p.m.</b> en horario GMT-5.
          <Popover content={`Colombia, Ecuador, Perú, Panamá.`}  placement="top" >
            <QuestionCircleFilled
              style={{
                color: "#A7A3A3",
                marginLeft: "8px",
                verticalAlign: "middle",
              }}
            />
          </Popover>
        </div>
        {this.props.isLoadingSynchronizations ? (
          <Loader />
        ) : (
          <div className="container-synchronization-content">
            {/* <Table loading={this.props.isLoadingSynchronizations} columns={this.tableColumns()} dataSource={this.props.synchronizations} />  */}
            <div>
              <div className="container-record-controlpanel__header">
                <div className="header-th">Fecha</div>
                <div className="header-th">Hora</div>
                <div className="header-th">Estado</div>
                <div className="header-th">Colaboradores actualizados</div>
                <div className="header-th">Colaboradores nuevos</div>
                <div className="header-th">Colaboradores eliminados</div>
                <div className="header-th">Error</div>
              </div>
              {this.props.synchronizations.map((synchronization) => {
                return (
                  <div className="container-record-controlpanel__body color-black" key={synchronization.id_synchronization}>
                    <div className="body-td">{synchronization.start_sync_date}</div>
                    <div className="body-td">{synchronization.start_sync_hour}</div>
                    <div className="body-td">{synchronization.type == 4 ? <span style={{color: '#55C8AE'}}>Exitoso</span> : <span style={{color: '#E37879'}}>Error</span>}</div>
                    <div className="body-td">{synchronization.count_update}</div>
                    <div className="body-td">{synchronization.count_new}</div>
                    <div className="body-td">{synchronization.count_delete}</div>
                    <div className="body-td">{this.showErrorLabel(synchronization.type, synchronization.id_synchronization)}</div>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </div>
    )
  }
}

Synchronization.propTypes = {
  /* dispatch: PropTypes.func.isRequired, */
}

const mapStateToProps = createStructuredSelector({
  synchronizations: makeSelectSynchronizations(),
  isLoadingSynchronizations: makeSelectIsLoadingSynchronizations()
})

function mapDispatchToProps(dispatch) {
  return {
    getSynchronizations: (params) =>
      dispatch(getSynchronizationsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "synchronization", reducer })
const withSaga = injectSaga({ key: "synchronization", saga })

export default compose(withReducer, withSaga, withConnect)(Synchronization)
